import React, { ChangeEvent, useState } from 'react';
import { PastProvider } from './models';
import ReferralMethod from './ReferralMethod';
import { client, consoleLogInDev, formatPhoneAsYouType, track, formatE164USPhoneNumber, isValidPhone } from 'shared';
import { getCopy, getOneTimeGiftCardCopy } from './referralCopy';
import { useUserContext } from 'UserContext';
import { useLocation } from 'react-router-dom';
import { trackReferralEngagement } from 'api/UserApi';
import { FamilyUserAttributes } from 'parent-portal/shared/UserAttributes';
import userAttributesApi from 'shared/UserAttributesApi';

const ReferralText = ({
    referredProvider,
    message,
    referralContext,
    promo,
    setPromoStep,
}: {
    referredProvider: PastProvider;
    message?: string;
    referralContext: string;
    promo?: string;
    setPromoStep?: (x: string) => void;
}) => {
    const [buttonText, setButtonText] = useState('Send');
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);
    const { user } = useUserContext();
    const location = useLocation();

    const changePhone = (e: ChangeEvent<{ value: string }>) => {
        setButtonText('Send');
        setPhone(formatPhoneAsYouType(e.target.value));
    };

    const trackAndSendText = () => {
        setLoading(true);
        if (user) {
            trackReferralEngagement(user.id, location.pathname, referralContext)
                .then((response) => response.id)
                .catch(consoleLogInDev)
                .then(sendText)
                .catch(consoleLogInDev)
                .finally(() => {
                    setLoading(false);
                    setButtonText('Sent!');
                    if (!!setPromoStep) {
                        setPromoStep('success');
                    }
                    if (!!promo && promo === 'OneTimeGiftCard') {
                        userAttributesApi.create(FamilyUserAttributes.OneTimeGiftCardSent);
                    }
                });
        }
        track('Referrals: Shared via Text', { phone, sitter: referredProvider });
    };

    function sendText(reid?: number) {
        const url =
            promo === 'OneTimeGiftCard'
                ? 'tracking/api/referral/send-gift-card/?phone_number=True'
                : 'tracking/api/referral/send/?phone_number=True';
        const body = {
            phoneNumber: formatE164USPhoneNumber(phone),
            sitter: referredProvider?.id > 0 ? referredProvider.id : null,
            message,
            default: message === getCopy(referredProvider) || message === getOneTimeGiftCardCopy(),
            reid: !!reid ? reid : null,
        };

        return client(url, {
            body,
        });
    }

    return (
        <ReferralMethod
            buttonText={buttonText}
            action={trackAndSendText}
            buttonProps={{ disabled: !isValidPhone(phone) }}
            inputProps={{
                placeholder: '(XXX) XXX-XXXX',
                value: phone,
                onChange: changePhone,
                error: !isValidPhone(phone),
                helperText: phone && !isValidPhone(phone) ? 'Please enter a valid phone number.' : '',
            }}
            loading={loading}
        />
    );
};

export default ReferralText;
